import { BenefitsState, BenefitsTypes } from './types';

export const INITIAL_STATE: BenefitsState = {
  benefitData: {
    id: '',
    name: '',
    data: '',
    status: 0,
    startDate: '',
    endDate: '',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
    Lines: [],
  },
  benefitCreated: {
    id: '',
    name: '',
    data: '',
    status: 0,
    startDate: '',
    endDate: '',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
    Lines: [],
  },
  attachBenefit: {
    benefitId: '',
    linesIds: [],
    transportOperatorId: '',
  },
  benefitSelected: {
    id: '',
    name: '',
    data: '',
    status: 0,
    startDate: '',
    endDate: '',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
    Lines: [],
  },
  currentOperation: 'none',
  benefitsList: [],
  benefitLines: [],
  totalCount: 0,
  error: false,
  loading: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

const listBenefitsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  benefitsList: INITIAL_STATE.benefitsList,
});

const listBenefitsSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  benefitsList: action.payload.benefitsList,
  totalCount: action.payload.totalCount,
});

const listBenefitsFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  benefitsList: INITIAL_STATE.benefitsList,
});

// Get Benefit
const getBenefitRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  benefitData: INITIAL_STATE.benefitData,
});

const getBenefitSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  benefitData: action.payload.benefitData,
});

const getBenefitFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  benefitData: INITIAL_STATE.benefitData,
});

// Create Benefit
const createBenefitRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  benefitCreated: INITIAL_STATE.benefitCreated,
});

const createBenefitSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  benefitCreated: action.payload.benefitCreated,
});

const createBenefitFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  benefitCreated: INITIAL_STATE.benefitCreated,
});

// Attach Benefit
const attachBenefitRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  attachBenefit: INITIAL_STATE.attachBenefit,
});

const attachBenefitSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  attachBenefit: action.payload.attachBenefit,
});

const attachBenefitFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  attachBenefit: INITIAL_STATE.attachBenefit,
});

// Update Benefit
const updateBenefitRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateBenefitSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateBenefitFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Benefit
const deleteBenefitRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteBenefitSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteBenefitFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// List Benefit Lines
const listBenefitLinesRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  benefitLines: INITIAL_STATE.benefitLines,
});

const listBenefitLinesSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  benefitLines: action.payload.benefitLines,
});

const listBenefitLinesFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  benefitLines: INITIAL_STATE.benefitLines,
});

// Set Current Operation
const setCurrentOperation = (state: any, action: any) => ({
  ...state,
  currentOperation: action.payload.operation,
});

// Set Benefit Selected
const setBenefitSelected = (state: any, action: any) => ({
  ...state,
  benefitSelected: action.payload.benefitSelected,
});

// Reset Benefit Selected
const resetBenefitSelected = (state: any) => ({
  ...state,
  benefitSelected: INITIAL_STATE.benefitSelected,
});

const reducer = createReducer(INITIAL_STATE, {
  [BenefitsTypes.LIST_BENEFITS_REQUEST]: listBenefitsRequest,
  [BenefitsTypes.LIST_BENEFITS_SUCCESS]: listBenefitsSuccess,
  [BenefitsTypes.LIST_BENEFITS_FAILURE]: listBenefitsFailure,

  [BenefitsTypes.GET_BENEFIT_REQUEST]: getBenefitRequest,
  [BenefitsTypes.GET_BENEFIT_SUCCESS]: getBenefitSuccess,
  [BenefitsTypes.GET_BENEFIT_FAILURE]: getBenefitFailure,

  [BenefitsTypes.CREATE_BENEFIT_REQUEST]: createBenefitRequest,
  [BenefitsTypes.CREATE_BENEFIT_SUCCESS]: createBenefitSuccess,
  [BenefitsTypes.CREATE_BENEFIT_FAILURE]: createBenefitFailure,

  [BenefitsTypes.ATTACH_BENEFIT_REQUEST]: attachBenefitRequest,
  [BenefitsTypes.ATTACH_BENEFIT_SUCCESS]: attachBenefitSuccess,
  [BenefitsTypes.ATTACH_BENEFIT_FAILURE]: attachBenefitFailure,

  [BenefitsTypes.UPDATE_BENEFIT_REQUEST]: updateBenefitRequest,
  [BenefitsTypes.UPDATE_BENEFIT_SUCCESS]: updateBenefitSuccess,
  [BenefitsTypes.UPDATE_BENEFIT_FAILURE]: updateBenefitFailure,

  [BenefitsTypes.DELETE_BENEFIT_REQUEST]: deleteBenefitRequest,
  [BenefitsTypes.DELETE_BENEFIT_SUCCESS]: deleteBenefitSuccess,
  [BenefitsTypes.DELETE_BENEFIT_FAILURE]: deleteBenefitFailure,

  [BenefitsTypes.LIST_BENEFIT_LINES_REQUEST]: listBenefitLinesRequest,
  [BenefitsTypes.LIST_BENEFIT_LINES_SUCCESS]: listBenefitLinesSuccess,
  [BenefitsTypes.LIST_BENEFIT_LINES_FAILURE]: listBenefitLinesFailure,

  [BenefitsTypes.SET_CURRENT_OPERATION]: setCurrentOperation,

  [BenefitsTypes.SET_BENEFIT_SELECTED]: setBenefitSelected,
  [BenefitsTypes.RESET_BENEFIT_SELECTED]: resetBenefitSelected,
});

export default reducer;
